import React, { useEffect, useRef } from "react";
import {
  Grid,
  Button,
  Typography,
  Box,
  Tooltip,
  Chip,
} from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import { useSnackbar } from "react-simple-snackbar";
import { useDispatch, useSelector } from "react-redux";
import { getBookedSeats, resetSeatsAction } from "../actions/seatActions";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LockIcon from "@material-ui/icons/Lock";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import "./SeatSelectionScrollbar.css";
import { getBogies } from "../actions/bogieActions";

/* ===============================
   VIP HELPER (NEW – UI SAFE)
================================ */
// const getVipSeatSet = (bogie) => {
//   const vipSet = new Set();

//   if (Array.isArray(bogie.vipSeatGroups)) {
//     bogie.vipSeatGroups.forEach(group => {
//       group.seats.forEach(seatNo => vipSet.add(seatNo));
//     });
//   }

//   if (Array.isArray(bogie.vipSeatNumbers)) {
//     bogie.vipSeatNumbers.forEach(seatNo => vipSet.add(seatNo));
//   }

//   return vipSet;
// };

// export function getAutoSelectedSeats({
//   bogies,
//   bookedSeats,
//   count,
//   alreadySelected = [],
// }) {
//   let seatsToSelect = [];
//   const bookedSet = new Set((bookedSeats || []).map(String));

//   for (const bogie of (bogies || []).filter((b) => b.isActive)) {
//     // Collect ALL VIP seat numbers (from groups OR old array)
//     const vipSeatSet = new Set();

//     // NEW: vipSeatGroups support
//     if (Array.isArray(bogie.vipSeatGroups)) {
//       bogie.vipSeatGroups.forEach((group) => {
//         group.seats.forEach((seatNo) => vipSeatSet.add(seatNo));
//       });
//     }

//     // BACKWARD COMPATIBILITY
//     if (Array.isArray(bogie.vipSeatNumbers)) {
//       bogie.vipSeatNumbers.forEach((seatNo) => vipSeatSet.add(seatNo));
//     }

//     for (let i = 1; i <= bogie.totalSeats; i++) {
//       // Skip VIP seats
//       if (vipSeatSet.has(i)) continue;

//       const seatId = `${bogie.name}${i}`;

//       if (!bookedSet.has(seatId) && !alreadySelected.includes(seatId)) {
//         seatsToSelect.push(seatId);
//         if (seatsToSelect.length === count) break;
//       }
//     }

//     if (seatsToSelect.length === count) break;
//   }

//   return seatsToSelect;
// }

// export function getAutoSelectedVipSeats({
//   bogies,
//   bookedSeats,
//   count,
//   alreadySelected = [],
// }) {
//   let seatsToSelect = [];
//   const bookedSet = new Set((bookedSeats || []).map(String));

//   for (const bogie of (bogies || []).filter((b) => b.isActive)) {
//     /* ===============================
//        NEW VIP GROUP LOGIC
//     =============================== */
//     if (Array.isArray(bogie.vipSeatGroups)) {
//       for (const group of bogie.vipSeatGroups) {
//         const groupSeatIds = group.seats.map(
//           (seatNo) => `${bogie.name}${seatNo}`
//         );

//         // Skip group if ANY seat is booked or already selected
//         const isGroupBlocked = groupSeatIds.some(
//           (seatId) =>
//             bookedSet.has(seatId) ||
//             alreadySelected.includes(seatId) ||
//             seatsToSelect.includes(seatId)
//         );

//         if (isGroupBlocked) continue;

//         // Stop if adding this group exceeds required count
//         if (seatsToSelect.length + groupSeatIds.length > count) continue;

//         seatsToSelect.push(...groupSeatIds);

//         if (seatsToSelect.length === count) {
//           return seatsToSelect;
//         }
//       }
//     }

//     /* ===============================
//        BACKWARD COMPATIBILITY
//        (old vipSeatNumbers)
//     =============================== */
//     if (Array.isArray(bogie.vipSeatNumbers)) {
//       for (const vipNo of bogie.vipSeatNumbers) {
//         const seatId = `${bogie.name}${vipNo}`;

//         if (
//           !bookedSet.has(seatId) &&
//           !alreadySelected.includes(seatId) &&
//           !seatsToSelect.includes(seatId)
//         ) {
//           seatsToSelect.push(seatId);
//           if (seatsToSelect.length === count) {
//             return seatsToSelect;
//           }
//         }
//       }
//     }
//   }

//   return seatsToSelect;
// }

// Utility function to auto-select regular seats (not tied to React or UI)
export function getAutoSelectedSeats({
  bogies,
  bookedSeats,
  count,
  alreadySelected = [],
}) {
  let seatsToSelect = [];
  const bookedSet = new Set((bookedSeats || []).map(String));
  for (const bogie of (bogies || []).filter((b) => b.isActive)) {
    for (let i = 1; i <= bogie.totalSeats; i++) {
      if (bogie.vipSeatNumbers.includes(i)) continue; // Skip VIP seats
      const seatId = `${bogie.name}${i}`;
      if (!bookedSet.has(seatId) && !alreadySelected.includes(seatId)) {
        seatsToSelect.push(seatId);
        if (seatsToSelect.length === count) break;
      }
    }
    if (seatsToSelect.length === count) break;
  }
  return seatsToSelect;
}

// Utility function to auto-select VIP seats (not tied to React or UI)
export function getAutoSelectedVipSeats({
  bogies,
  bookedSeats,
  count,
  alreadySelected = [],
}) {
  let seatsToSelect = [];
  const bookedSet = new Set((bookedSeats || []).map(String));
  for (const bogie of (bogies || []).filter((b) => b.isActive)) {
    for (const vipNo of bogie.vipSeatNumbers) {
      const seatId = `${bogie.name}${vipNo}`;
      if (!bookedSet.has(seatId) && !alreadySelected.includes(seatId)) {
        seatsToSelect.push(seatId);
        if (seatsToSelect.length === count) break;
      }
    }
    if (seatsToSelect.length === count) break;
  }
  return seatsToSelect;
}

const SeatSelection = ({
  open,
  selectedSeats,
  setSelectedSeats,
  tripDate,
  tripNumber,
  showResetButton,
  onResetTrip,
  currentInvoiceId,
  resetTrigger,
  autoSelectCount,
}) => {
  const [openSnackbar] = useSnackbar();
  const dispatch = useDispatch();
  const {
    bookedSeats = [],
    loading,
    error,
  } = useSelector((state) => state.seatReducer || {});
  const { bogies } = useSelector((state) => state.bogieReducer || {});
  const [openDialog, setOpenDialog] = React.useState(false);

  // console.log("Auto-select count:", autoSelectCount);

  useEffect(() => {
    dispatch(getBogies());
  }, [dispatch]);

  console.log("Bogies 42:", bogies);

  const wasOpen = useRef(false);
  useEffect(() => {
    dispatch(getBookedSeats(tripDate, tripNumber));
  }, [dispatch, tripDate, tripNumber]);

  // --- AUTO-SELECT REGULAR SEATS ON MOUNT OR WHEN DATA CHANGES ---
  useEffect(() => {
    if (
      open &&
      !loading &&
      Array.isArray(bookedSeats) &&
      Array.isArray(bogies) &&
      bogies.length > 0 &&
      bookedSeats.length >= 0 &&
      autoSelectCount > 0 &&
      selectedSeats.length < autoSelectCount &&
      !wasOpen.current
    ) {
      wasOpen.current = true;

      let seatsToSelect = [];
      const bookedSet = new Set((bookedSeats || []).map(String));
      for (const bogie of bogies.filter((b) => b.isActive)) {
        for (let i = 1; i <= bogie.totalSeats; i++) {
          if (bogie.vipSeatNumbers.includes(i)) continue; // Skip VIP seats
          const seatId = `${bogie.name}${i}`;
          if (!bookedSet.has(seatId) && !selectedSeats.includes(seatId)) {
            seatsToSelect.push(seatId);
            if (seatsToSelect.length === autoSelectCount) break;
          }
        }
        if (seatsToSelect.length === autoSelectCount) break;
      }

      if (seatsToSelect.length > 0) {
        setSelectedSeats([...selectedSeats, ...seatsToSelect]);
        openSnackbar(`${seatsToSelect.length} seat(s) auto-selected!`);
      }
    }
    if (!open) {
      wasOpen.current = false;
    }
  }, [
    open,
    loading,
    bookedSeats,
    bogies,
    autoSelectCount,
    selectedSeats,
    setSelectedSeats,
    openSnackbar,
  ]);

  const handleResetSeats = async () => {
    const newTripNumber = await dispatch(
      resetSeatsAction(tripDate, tripNumber)
    );
    openSnackbar(
      `All seats have been reset for ${tripDate} trip ${tripNumber}!`
    );
    if (onResetTrip) onResetTrip(newTripNumber);
    wasOpen.current = false;
  };

  // A physical double-click dispatches two separate "click" events for the
  // same seat. handleSeatToggle is a pure toggle, so two calls for the same
  // seatId cancel out (select, then immediately deselect) even though state
  // updates correctly against the latest value. Debounce repeat clicks on the
  // same seat so a double-click behaves like a single click (select), not a
  // toggle-twice.
  const lastToggleRef = useRef({});
  const DOUBLE_CLICK_GUARD_MS = 350;

  const handleSeatToggle = (seatId) => {
    const now = Date.now();
    if (now - (lastToggleRef.current[seatId] || 0) < DOUBLE_CLICK_GUARD_MS) {
      return;
    }
    lastToggleRef.current[seatId] = now;

    if (bookedSeats.includes(seatId) && !selectedSeats.includes(seatId)) return;
    setSelectedSeats((prev) => {
      if (prev.includes(seatId)) {
        return prev.filter((s) => s !== seatId);
      }
      if (prev.length >= autoSelectCount) {
        // Replace the oldest selected seat (FIFO)
        return [...prev.slice(1), seatId];
      }
      return [...prev, seatId];
    });
  };

  const getSeatStats = React.useMemo(() => {
    const stats = {};
    bogies
      .filter((b) => b.isActive)
      .forEach((bogie) => {
        let vip = 0,
          regular = 0;
        for (let i = 1; i <= bogie.totalSeats; i++) {
          const id = `${bogie.name}${i}`;
          if (bookedSeats.includes(id) && !selectedSeats.includes(id)) continue;
          bogie.vipSeatNumbers.includes(i) ? vip++ : regular++;
        }
        stats[bogie.name] = { vip, regular };
      });
    return stats;
  }, [bogies, bookedSeats, selectedSeats]);

  // Helper to get seat status
  const getSeatStatus = (seatId, seatNo, vipSeatNumbers) => {
    if (
      bookedSeats.map(String).includes(String(seatId)) &&
      !selectedSeats.includes(seatId)
    ) {
      return "booked";
    }
    if (selectedSeats.includes(seatId)) {
      return "selected";
    }
    if (vipSeatNumbers.includes(seatNo)) {
      return "vip";
    }
    return "regular";
  };

  const VIP_COLORS = {
    couple: { bg: "#E3F2FD", border: "#2196F3" },
    family: { bg: "#FCE4EC", border: "#E91E63" },
  };

  return (
    <Box
      mt={3}
      style={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      {/* Reset Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Reset</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to reset all seats for{" "}
            <strong style={{ color: "#000" }}>{tripDate}</strong> trip{" "}
            <strong style={{ color: "#000" }}>{tripNumber}</strong>? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setOpenDialog(false);
              handleResetSeats();
            }}
            color="secondary"
            variant="contained"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Typography variant="h6" gutterBottom>
        Select Seats (Date: {tripDate}, Trip: {tripNumber})
      </Typography>
      {showResetButton && (
        <Box mb={2}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setOpenDialog(true)}
            style={{ marginRight: 8 }}
            disabled={loading}
          >
            Make New Trip
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => dispatch(getBookedSeats(tripDate, tripNumber))}
            disabled={loading}
          >
            Refresh Seats
          </Button>
        </Box>
      )}
      {/* Seat legend */}
      <Box display="flex" alignItems="center" mb={2} flexWrap="wrap">
        <Box display="flex" alignItems="center" mr={2}>
          <Box
            width={24}
            height={24}
            bgcolor="#E3F2FD"
            border="2px solid #2196F3"
            mr={1}
          />
          <Typography variant="body2">Couple VIP</Typography>
        </Box>
        <Box display="flex" alignItems="center" mr={2}>
          <Box
            width={24}
            height={24}
            bgcolor="#FCE4EC"
            border="2px solid #E91E63"
            mr={1}
          />
          <Typography variant="body2">Family VIP</Typography>
        </Box>
        <Box display="flex" alignItems="center" mr={2}>
          <Box
            width={24}
            height={24}
            bgcolor="#fff"
            border="1px solid #ccc"
            mr={1}
          />
          <Typography variant="body2">Regular</Typography>
        </Box>
        <Box display="flex" alignItems="center" mr={2}>
          <Box
            width={24}
            height={24}
            bgcolor="#e0e0e0"
            border="1px solid #ccc"
            mr={1}
          />
          <Typography variant="body2">Booked</Typography>
        </Box>
        <Box display="flex" alignItems="center" mr={2}>
          <Box
            width={24}
            height={24}
            bgcolor="#1976d2"
            border="1px solid #1976d2"
            mr={1}
          />
          <Typography variant="body2">Selected</Typography>
        </Box>
      </Box>
      {loading && <Typography>Loading seats...</Typography>}
      {error && <Typography color="error">{error}</Typography>}
      {bogies.length === 0 && !loading && (
        <Typography>No active bogies available.</Typography>
      )}
      <div
        className="slim-scrollbar"
        style={{ flex: "1 1 auto", minHeight: 0 }}
      >
        {bogies
          .filter((b) => b.isActive)
          .map((bogie) => (
            <Box key={bogie.id} mb={3}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="subtitle1">Bogie {bogie.name}</Typography>
                <Box>
                  <Chip
                    label={`VIP: ${getSeatStats[bogie.name]?.vip || 0}`}
                    size="small"
                    color="secondary"
                    style={{ marginRight: 8 }}
                  />
                  <Chip
                    label={`Regular: ${getSeatStats[bogie.name]?.regular || 0}`}
                    size="small"
                    color="primary"
                  />
                </Box>
              </Box>

              {(() => {
                const ROWS = 3;

                return (
                  <Box
                    sx={{
                      overflowX: "auto",
                      overflowY: "hidden",
                      width: "100%",
                    }}
                  >
                    <Box
                      display="grid"
                      gridTemplateRows={`repeat(${ROWS}, 40px)`} 
                      gridAutoFlow="column" 
                      columnGap={12}
                      rowGap={12}
                      mt={1}
                      sx={{
                        minWidth: "max-content", 
                        paddingBottom: 1,
                      }}
                    >
                      {Array.from({ length: bogie.totalSeats }).map(
                        (_, index) => {
                          const seatNo = index + 1;
                          const seatId = `${bogie.name}${seatNo}`;

                          const isBooked =
                            bookedSeats.map(String).includes(String(seatId)) &&
                            !selectedSeats.includes(seatId);

                          const isSelected = selectedSeats.includes(seatId);

                          // VIP detection
                          let vipType;
                          if (Array.isArray(bogie.vipSeatGroups)) {
                            for (const group of bogie.vipSeatGroups) {
                              if (group.seats.includes(seatNo)) {
                                vipType = group.type;
                                break;
                              }
                            }
                          }

                          // COLORS (UNCHANGED)
                          let bgColor = "#fff";
                          let border = "1px solid #ccc";
                          let textColor = "#333";

                          if (vipType === "couple") {
                            bgColor = "#E3F2FD";
                            border = "2px solid #2196F3";
                          } else if (vipType === "family") {
                            bgColor = "#FCE4EC";
                            border = "2px solid #E91E63";
                          }

                          if (isSelected) {
                            bgColor = "#1976d2";
                            textColor = "#fff";
                          } else if (isBooked) {
                            bgColor = "#e0e0e0";
                            textColor = "#b71c1c";
                          }

                          return (
                            <Tooltip
                              key={seatId}
                              title={
                                isBooked
                                  ? "Booked"
                                  : vipType === "couple"
                                  ? "Couple VIP"
                                  : vipType === "family"
                                  ? "Family VIP"
                                  : "Regular Seat"
                              }
                            >
                              <span>
                                <Button
                                  disabled={isBooked}
                                  onClick={() => handleSeatToggle(seatId)}
                                  style={{
                                    width: 36,
                                    height: 36,
                                    
                                    fontSize: 14,
                                    backgroundColor: bgColor,
                                    color: textColor,
                                    border,
                                    position: "relative",
                                  }}
                                >
                                  {seatNo}

                                  {(vipType === "couple" ||
                                    vipType === "family") &&
                                    !isBooked &&
                                    !isSelected && (
                                      <StarIcon
                                        style={{
                                          fontSize: 14,
                                          color:
                                            vipType === "couple"
                                              ? "#2196F3"
                                              : "#E91E63",
                                          position: "absolute",
                                          top: -5,
                                          right: -5,
                                        }}
                                      />
                                    )}

                                  {isBooked && (
                                    <LockIcon
                                      style={{
                                        fontSize: 16,
                                        color: "#b71c1c",
                                        position: "absolute",
                                        top: -5,
                                        right: -5,
                                      }}
                                    />
                                  )}
                                  {isSelected && (
                                    <CheckCircleIcon
                                      style={{
                                        fontSize: 16,
                                        color: "#fff",
                                        position: "absolute",
                                        top: -5,
                                        left: -5,
                                      }}
                                    />
                                  )}
                                </Button>
                              </span>
                            </Tooltip>
                          );
                        }
                      )}
                    </Box>
                  </Box>
                );
              })()}
            </Box>
          ))}
      </div>
      
    </Box>
  );
};

export default SeatSelection;


{/* <div className="slim-scrollbar" style={{ flex: '1 1 auto', minHeight: 0 }}>
{bogies.filter(b => b.isActive).map((bogie) => {
  const rows = 3;
  const cols = Math.ceil(bogie.totalSeats / rows);

  return (
    <Box key={bogie.id} mb={3} style={{ overflowX: "auto" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle1">Bogie {bogie.name}</Typography>
        <Box>
          <Chip label={`VIP: ${getSeatStats[bogie.name]?.vip || 0}`} size="small" color="secondary" style={{ marginRight: 8 }} />
          <Chip label={`Regular: ${getSeatStats[bogie.name]?.regular || 0}`} size="small" color="primary" />
        </Box>
      </Box>
      <Grid container spacing={1} wrap="nowrap">
        {Array.from({ length: rows }).map((_, row) =>
          Array.from({ length: cols }).map((_, col) => {
            const seatNo = col * rows + row + 1;
            if (seatNo > bogie.totalSeats) return null;

            const seatId = `${bogie.name}${seatNo}`;
            const status = getSeatStatus(seatId, seatNo, bogie.vipSeatNumbers);
            const isBooked = status === "booked";
            const isSelected = status === "selected";
            const isVIP = status === "vip";
            const vipType = bogie.vipSeatGroups?.[seatNo]; // e.g., 'couple' or 'family'

            const bgColor = isBooked
              ? "#e0e0e0"
              : isSelected
                ? "#1976d2"
                : isVIP
                  ? VIP_COLORS[vipType]?.bg || "#fff"
                  : "#fff";

            const borderColor = isVIP ? VIP_COLORS[vipType]?.border : "#ccc";

            return (
              <Grid item key={seatId} style={{ minWidth: 36 }}>
                <Tooltip
                  title={
                    isBooked
                      ? "Booked"
                      : isSelected
                        ? "Selected"
                        : isVIP
                          ? `${vipType?.charAt(0).toUpperCase() + vipType?.slice(1)} VIP`
                          : "Regular Seat"
                  }
                >
                  <span>
                    <Button
                      variant={isSelected ? "contained" : "outlined"}
                      disabled={isBooked}
                      onClick={() => handleSeatToggle(seatId)}
                      style={{
                        backgroundColor: bgColor,
                        color: isBooked ? "#b71c1c" : isSelected ? "#fff" : "#333",
                        border: `2px solid ${borderColor}`,
                        minWidth: 36,
                        height: 36,
                        fontSize: 14,
                        position: "relative",
                        opacity: isBooked ? 0.6 : 1,
                        boxShadow: isSelected ? "0 0 8px #1976d2" : undefined,
                        transition: "all 0.2s",
                        cursor: isBooked ? "not-allowed" : "pointer",
                      }}
                      onMouseOver={e => {
                        if (!isBooked) e.currentTarget.style.transform = "scale(1.1)";
                      }}
                      onMouseOut={e => {
                        if (!isBooked) e.currentTarget.style.transform = "scale(1)";
                      }}
                    >
                      {seatNo}
                      {isVIP && !isSelected && !isBooked && (
                        <StarIcon
                          style={{
                            fontSize: 14,
                            color: VIP_COLORS[vipType]?.border || "#FFD700",
                            position: "absolute",
                            top: -5,
                            right: -5,
                          }}
                        />
                      )}
                      {isBooked && (
                        <LockIcon
                          style={{
                            fontSize: 16,
                            color: "#b71c1c",
                            position: "absolute",
                            top: -5,
                            right: -5,
                          }}
                        />
                      )}
                      {isSelected && (
                        <CheckCircleIcon
                          style={{
                            fontSize: 16,
                            color: "#fff",
                            position: "absolute",
                            top: -5,
                            left: -5,
                          }}
                        />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            );
          })
        )}
      </Grid>
    </Box>
  );
})}
</div> */}